import isFunction from 'lodash/isFunction';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';

const finalFormLoadingDecorator = ({ field, updates, isEqual }) => {
  // Loop over updates key and add ignore functionality
  const decoratedUpdates = Object.keys(updates).reduce((memo, key) => {
    memo[key] = (value, allValues, oldValues) => {
      // Ignore update when oldValues.key does not exist
      if (isEmpty(oldValues)) {
        return allValues?.key;
      }

      const updateTo = updates[key];
      return isFunction(updateTo) ? updateTo(value, allValues, oldValues) : updateTo;
    };

    return memo;
  }, {});

  let output = {
    field,
    updates: decoratedUpdates,
  };

  // Only add isEqual when it's set
  if (isFunction(isEqual)) {
    output.isEqual = isEqual;
  }

  if(isArray(field)) {
    output = field.map(f => ({ ...output, field: f }))
  }

  return output;
};

export default finalFormLoadingDecorator;
